/* RESPONSIBLE TEAM: team-data-foundations */

const PARAM_DESCRIPTOR_SOURCE_FIN = 'fin';
const PARAM_DESCRIPTOR_SOURCE_CUSTOM = 'custom';
const PARAM_DESCRIPTOR_SOURCE_ATTRIBUTE = 'attribute';
const PARAM_DESCRIPTOR_SOURCE_IGNORE = 'ignore';

export {
  PARAM_DESCRIPTOR_SOURCE_FIN,
  PARAM_DESCRIPTOR_SOURCE_CUSTOM,
  PARAM_DESCRIPTOR_SOURCE_ATTRIBUTE,
  PARAM_DESCRIPTOR_SOURCE_IGNORE,
};
